/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Icon, Modal } from 'semantic-ui-react'
import EditModal from '../../commonComponent/editModal'
import DeleteModal from '../../deleteComponent/deleteModal'
import DeleteAxios from '../../axiosComponent/deleteAxios'
import FormikEditUsers from './editUser'
import cogoToast from 'cogo-toast'

function UserActionButton(props) {
    console.log(props,'props')
    const [editModal, setEditModal] = useState(false)
    const [openBox, setopenBox] = useState(false)
    const [success, setsuccess] = useState(false)
    let handleEditClose = () => {
        setEditModal(false)
    }
    let handleClose = () => {
        setopenBox(false)
    }
    let handleDelete = () => {
        setsuccess(true)
        let id = props.data.fullData.u_id
        console.log("Props ", props)
        DeleteAxios({
            url: `masters/userMaster/${id}`,
            deleteItems: {
                uId: id,
                userName:props.data.username
            },
            deleted: (data) => {
                if (data && data.status === 200) {
                    cogoToast.success(data.message)
                    setTimeout(() => {
                        setsuccess(false)
                        props.agGridReact.props.reload(true)
                    }, 500);
                }else if(data.status == 204){
                    cogoToast.error(data.message)
                }
            }
        })

    }
    let handleOpenEdit = (e) => {
        setEditModal(true)
    }
    let handleOpenDelete = (e) => {
        setopenBox(true)
    }
    // console.log(props.data)
    return (
        <>
            {props.data.username !== "elixir1371" && <Button disabled={props.data && props.data.customerNo === 0  ? true : false} onClick={handleOpenEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button>}
            {props.data.username !== "elixir1371" && <Button disabled={props.data && props.data.customerNo === 0 ? true : false} onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button>}
            <DeleteModal isloading={success} open={openBox} onClose={handleClose} handleDelete={handleDelete} />
            <EditModal size="tiny" open={editModal} onClose={handleEditClose}>
                <Modal.Header>Edit User</Modal.Header>
                <FormikEditUsers handleClose={handleEditClose}
                    users={props.data && props.data.fullData} getUpdate={props.agGridReact.props} />
            </EditModal>
        </>
    )
}

export default UserActionButton
